import React from 'react';
import IntegrationBlock from '../../index';
import StatusBlock from '../StatusBlock';
import TechData from '../TechData';

const TransportInfo = (props) => {
  const { data, modalType, isChangeable } = props;

  return (
    <>
      {data !== undefined && data !== null && (
        <>
          <IntegrationBlock
            title="Транспортная информация"
            isChangable={isChangeable}
            modalType={modalType}
            modalData={data}
            isSaveable={data?.supplyData?.supplyId !== undefined}
          >
            <h5>Водитель</h5>
            <p>Фио: {data.supplyData?.driverInfo?.driverName}</p>
            <p>Номер телефона: {data.supplyData?.driverInfo?.driverPhone}</p>
            <h5>Машина</h5>
            <p>Марка/модель: {data.supplyData?.driverInfo?.vehicleModel}</p>
            <p>Номер: {data.supplyData?.driverInfo?.vehicleNumber}</p>
          </IntegrationBlock>
          <StatusBlock
            status={data.techData?.driverInfoTechData?.supplyDriverStatus}
            syncro={data.techData?.driverInfoTechData?.supplyDriverSynchronized}
            draftErrors={data.techData?.driverInfoTechData?.supplyDriverErrors}
          />
          <TechData
            code={data.techData?.driverInfoTechData?.supplyDriverOperationId}
            date={data.techData?.driverInfoTechData?.supplyDriverRequestTs}
            ozonDate={data.techData?.driverInfoTechData?.supplyDriverSyncResultTs}
          />
        </>
      )}
    </>
  );
};

export default TransportInfo;
